import { render, staticRenderFns } from "./BroadcastPendingUpdateModal.vue?vue&type=template&id=394e1684&scoped=true&"
import script from "./BroadcastPendingUpdateModal.vue?vue&type=script&lang=js&"
export * from "./BroadcastPendingUpdateModal.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastPendingUpdateModal.vue?vue&type=style&index=0&id=394e1684&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394e1684",
  null
  
)

export default component.exports